import { ListElement, ElementsContainer, ListContainer, ListElementTitleContainer } from "./styles";
import { DefaultImage } from "components/shareable/StatCard/styles";
import Sty, { Container } from "modules/Sty";
import UnlockChartImage from "assets/images/unlock-data-chart.svg";
import useScreen from "Hooks/useScreen";
import UnlockDataBanner from "components/shareable/UnlockDataBanner";
import useCurrentBrand from 'Hooks/useCurrentBrand';
import { CSSProperties } from "react";
import CardSymphony from "elements/CardSymphony";
import { clsx, makeKey } from "modules/Utils";

type SitesListItem = {
    title: string;
    image_url?: string;
    value?: string | number;
    subValue?: string | number;
}

interface SitesListProps {
    className?: string;
    style?: CSSProperties;
    items?: SitesListItem[];
    title: string;
    numbered?: boolean;
}

const SitesList = ({
    className,
    style,
    items = [],
    title,
    numbered,
}: SitesListProps) => {
    const { mobileView } = useScreen();
    const { isPaidBrand } = useCurrentBrand();

    return (
        <CardSymphony
            className={clsx('sitesListComponet', className)}
            title={title}
            isPadding16
            size="small"
            style={{ border: Sty.border, alignSelf: 'stretch' }}
        >
            {!isPaidBrand ?
                <ElementsContainer
                    className="sitesListElementsContainer1"
                    alignItems={items.length === 0 ? 'center' : 'flex-start'}
                >
                    <UnlockDataBanner
                        title={title}
                        description="Get more insights with Symphony Lite"
                        image={UnlockChartImage}
                        hideImage={mobileView}
                        source={`Website Overall Dashboard - ${title}`}
                        unlockedWithLite={true}
                    />
                </ElementsContainer>
                :
                <ElementsContainer
                    className="sitesListElementsContainer2"
                    alignItems={items.length === 0 ? 'center' : 'flex-start'}
                >
                    {items.length === 0 &&
                        <div className="sitesListNoData" style={Sty.text16grey}>
                            No data found
                        </div>
                    }
                    {items.map((item, index) => (
                        <div
                            key={makeKey('sites-list-item', index)}
                            className="sitesListItem"
                            style={sty.sitesListItem}
                        >
                            <ListElementTitleContainer
                                className="sitesListItemTitleContainer1"
                                style={{ flex: 3 }}
                            >
                                {numbered &&
                                    <div className="sitesListNumber">
                                        {index + 1}
                                    </div>
                                }
                                {item.image_url &&
                                    <DefaultImage
                                        className="sitesListItemImage"
                                        src={item.image_url}
                                        width='48px'
                                        height='48px'
                                        borderRadius='8px'
                                        objectFit='scale-down'

                                    />
                                }
                                <Container
                                    className="sitesListItemTitleContainer2"
                                    overflow="hidden"
                                    textOverflow="ellipsis"
                                >
                                    <div
                                        className="sitesListTitle"
                                        style={Sty.text16grey}
                                    >
                                        {item.title}
                                    </div>
                                </Container>
                            </ListElementTitleContainer>
                            <div className="sitesListValue" style={sty.sitesListValue}>
                                <div className="sitesListValueText" style={Sty.text16bold}>
                                    {item.value}
                                </div>
                                {item.subValue &&
                                    <div className="sitesListValueSubValue" style={Sty.text16grey}>
                                        {item.subValue}
                                    </div>
                                }
                            </div>
                        </div>
                    ))}
                </ElementsContainer>
            }
        </CardSymphony >
    )
}

const sty: Record<string, CSSProperties> = {
    sitesListComponent: {
        width: '100%',
        border: Sty.border,
        borderRadius: 8,
        padding: 16,
    },
    sitesListItem: {
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        width: '100%',
    },
    sitesListValue: {
        display: 'flex',
        flexDirection: 'column',
        width: 'fit-content',
        flexShrink: 0,
        flex: 1,
        textAlign: 'right',
    }
}

export default SitesList;